import { CLEAR_BUSINESS, SET_BUSINESS } from '../actions/types';

const initialState = {
  // null means "asked, got nothing" -- a 404. undefined means "not asked yet".
  // The detail page needs to tell those apart or it renders Not Found for a
  // frame on every navigation.
  item: undefined,
};

export default function business(state = initialState, action = {}) {
  switch (action.type) {
    case SET_BUSINESS:
      return { item: action.payload ?? null };

    case CLEAR_BUSINESS:
      return { item: undefined };

    default:
      return state;
  }
}
